import React from "react";

import CodeFigure from "./CodeFigure";

export default function AsciiCinemaSession({ castid, autostart, ...rest }) {
  const href = `https://asciinema.org/a/${castid}?autoplay=${autostart}`;
  const src = `https://asciinema.org/a/${castid}.svg`;

  return (
    <CodeFigure {...rest}>
      <a href={href} target="_blank">
        <img src={src} width="100%" />
      </a>
    </CodeFigure>
  );
}
